import DomainCommon from './common';

const MedicalService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical`,
                resolve, reject
            });
        });
    },
    findById: (medicalId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}`,
                resolve, reject
            });
        });
    },
    setMedicalRole: ({medicalId,role}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}/role`,
                jsonBody:{role},
                resolve, reject
            });
        });
    },
    updateMedical: ({medical, medical: {id}}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${id}`,
                jsonBody: medical,
                resolve, reject
            });
        });
    },
    setMedicalLevel: ({medicalId, level}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}/level`,
                jsonBody:{level},
                resolve, reject
            });
        });
    },
    validate: ({medicalId, institution, validateFail}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}/validate`,
                jsonBody: {institution, validateFail},
                resolve, reject
            });
        });
    },
    enable: (medicalId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}/enable`,
                resolve, reject
            });
        });
    },
    disable: (medicalId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}/disable`,
                resolve, reject
            });
        });
    },
    notified: (medicalId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}/notified`,
                resolve, reject
            });
        });
    },
    changeHospital: ({medicalId, hospitalId}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/medical/${medicalId}/institution`,
                jsonBody: {institution: {id: hospitalId}},
                resolve, reject
            });
        });
    },
};

const MissionService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission`,
                resolve, reject
            });
        });
    },
    findById: (missionId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}`,
                resolve, reject
            });
        });
    },
    dispatch: ({missionId, medicalIds}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/dispatch`,
                jsonBody: {missionId, medicalIds},
                resolve, reject
            });
        });
    },
    assign: ({missionId, targetMedicalId}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/mission/${missionId}/assign`,
                jsonBody: {missionId, targetMedicalId},
                resolve, reject
            });
        });
    },
};


const UserService = {
    findById: (userId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/user/${userId}`,
                resolve, reject
            });
        });
    },
    updateAvatar: ({userId, base64_src, url}) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/user/${userId}/avatar`,
                jsonBody: {base64_src, url},
                resolve, reject
            });
        });
    },
};

const CallHelperService = {medical: MedicalService, mission: MissionService, user: UserService};

export default CallHelperService;



// WEBPACK FOOTER //
// ./src/service/callHelper.js